<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=5" />
    <meta name="robots" content="noindex, nofollow" />
    <meta name="googlebot" content="noindex" />
    <meta
      name="description"
      content="The Singapore Student Learning Space (SLS) allows all students to have equal and open access to quality curriculum-aligned resources, enabling students to take greater ownership of their learning. The SLS also complements classroom teaching, and supports teachers with quality curriculum-aligned resources."
    />
    <meta
      name="keywords"
      content="Student Learning Space, SLS, Ministry of Education, MOE Singapore, Singapore Student Learning Space, Singapore SLS"
    />
    <link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
    <link rel="manifest" href="/favicons/site.webmanifest" />
    <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg" />
    <meta name="msapplication-TileColor" content="#0b233f" />
    <meta name="theme-color" content="#2b63d9" />
    <script
      async
      id="youtube-iframe-js-api-script"
      src="https://www.youtube.com/iframe_api"
    ></script>
    <script type="module" src="/main.ts"></script>
    <title>SLS</title>
  </head>

  <body>
    <noscript>
      <strong
        >We're sorry but SLS doesn't work properly without JavaScript enabled. Please enable it to
        continue.</strong
      >
    </noscript>
    <div id="app"></div>
    <!-- built files will be auto injected -->
  </body>
</html>
